import { useForm } from "react-hook-form";
import "../../css/Home.css";
import Nav from "../../components/Nav";
import { Login } from "../../services/AuthService";
import useSignIn from "react-auth-kit/hooks/useSignIn";
import { useAxiosInstance } from "../../services/Interceptor";
import { toast } from "react-toastify";
import { Link, Navigate } from "react-router-dom";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import PasswordInput from "../../components/common/PasswordInput";
import { useSearchParams } from "react-router-dom";

export default function SignIn({ color }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const signIn = useSignIn();
  const apiInstance = useAxiosInstance();
  const isAuthenticated = useIsAuthenticated();
  const [searchParams] = useSearchParams();

  const handleLogin = async (formData) => {
    const credentials = { email: formData.email, password: formData.password };

    if (credentials.password.length < 6) {
      toast.error("Invalid credentials. Please check your email or password.");
      return;
    }

    try {
      const data = await Login(apiInstance, credentials);

      if (!data || !data.user || !data.user.role) {
        toast.error(
          "Invalid credentials. Please check your email or password.",
        );
        return;
      }

      const role = data.user.role;
      if (data.verifyGuid) {
        localStorage.setItem("_auth_verify_guid", data.verifyGuid);
      }

      const isAuthenticated = signIn({
        auth: {
          token: data.accessToken,
          type: "Bearer",
        },
        expiresIn: 3600,
        userState: { user: data.user },
        refresh: data.refreshToken,
      });

      if (isAuthenticated) {
        const profileBaseRole =
          role === "highschool" ? "highschool-coach" : role;
        const roleRedirects = {
          admin: "/admin/dashboard",
          university: "/university/dashboard",
          highschool: "/highschool/dashboard",
          athlete: "/athlete/dashboard",
        };

        if (searchParams.size > 0 && searchParams.get("back-to-profile")) {
          window.location.href = `/${profileBaseRole}/athlete-profile/${searchParams.get("profile")}`;
        } else {
          const redirect_url = roleRedirects[role];
          if (redirect_url) {
            window.location.href = redirect_url;
          } else {
            toast.error("Unknown role. Please contact support.");
          }
        }
      } else {
        toast.error("Login failed. Please try again.");
      }
    } catch (error) {
      console.error("Error during login:", error);
      const errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "Invalid Email or Password.";

      toast.error(errorMessage);
    }
  };

  return (
    <>
      {isAuthenticated && <Navigate to="/" />}
      <Nav />
      <div className="flex items-center justify-center mt-6">
        <div className="w-full max-w-4xl p-0">
          <h2 className="text-white undefined-600 uppercase font-bold px-6 text-xl pb-2">
            {" "}
            Sign In
          </h2>

          <form
            onSubmit={handleSubmit(handleLogin)}
            className="container mx-auto px-4"
          >
            <div className="px-2 mb-20">
              <div className="form-field mt-4">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  aria-invalid={errors.email ? "true" : "false"}
                  name="email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Invalid email format",
                    },
                  })}
                  placeholder="Enter your email"
                />
                {errors.email && (
                  <p className="text-red-500">{errors.email.message}</p>
                )}
              </div>
              <PasswordInput
                className="w-full"
                label="Password"
                name="password"
                register={register}
                validation={{ required: "Password is required" }}
                placeholder="Enter your password"
                errors={errors}
                autoComplete="current-password"
                inputClassName="w-full pr-10 border rounded px-3 py-2"
              />
              <div className="flex justify-between mt-6">
                <button
                  type="submit"
                  className="bg-red-500 text-white uppercase rounded px-6 py-2 text-center hover:bg-red-700 cursor-pointer"
                >
                  Sign In
                </button>
                <Link
                  className="text-red-500 hover:underline cursor-pointer uppercase"
                  to="/forgot-password"
                >
                  Forgot Password?
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
